import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { RequisitionService } from '../../../service/requisition/requisition.service';
import { Attendance } from '../../../class/attendance';

@Component({
  selector: 'app-requisition',
  templateUrl: './requisition.component.html',
  styleUrls: ['./requisition.component.scss']
})
export class RequisitionComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoRequisition: Attendance;
    public requisition: Attendance;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public requisitionService: RequisitionService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelRequisition () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/requisitions/requisition/requisition.component.ts